import Validatable from "~/mixins/validatable";
import VisualizationBuilderModel from "~/models/tracked/visualizationBuilderModel";
import IRepo from "~/interfaces/repo";
import Repo from "~/state/modules/repo";

interface IChangedIndexedFields {
  id: string
  added_fields: string[]
  removed_fields: string[]
}

export default class VisualizationSourceChangedIndexedFields extends Validatable(VisualizationBuilderModel) implements IChangedIndexedFields {
  id: string
  added_fields: string[] = []
  removed_fields: string[] = []

  constructor(json) {
    super()
    this.defineProperty('added_fields', json.added_fields)
    this.defineProperty('removed_fields', json.removed_fields)
  }

  static repo: IRepo<VisualizationSourceChangedIndexedFields> = new Repo<VisualizationSourceChangedIndexedFields>('visualizationSourceChangedIndexedFields', VisualizationSourceChangedIndexedFields, {});
  repo: IRepo<this>;

  addToRepo(): void {
    VisualizationSourceChangedIndexedFields.repo.add(this);
  }

  clearChangedFields(): void {
    this.added_fields = []
    this.removed_fields = []
  }
}